module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "affix"
  }, [_c('div', {
    staticClass: "affix-wrapper"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackTop),
      expression: "showBackTop"
    }],
    staticClass: "affix-item back-to-top",
    on: {
      "click": _vm.backTop,
      "mouseenter": function($event) {
        _vm.v1 = true;
      },
      "mouseleave": function($event) {
        _vm.v1 = false;
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-up"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v1),
      expression: "v1"
    }],
    staticClass: "drop-out"
  }, [_c('p', [_vm._v("返回顶部")])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "affix-item qq-contact",
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=276481348&site=qq&menu=yes",
      "title": "商务合作",
      "alt": "商务合作"
    },
    on: {
      "mouseenter": function($event) {
        _vm.v2 = true;
      },
      "mouseleave": function($event) {
        _vm.v2 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/QQ.png")
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v2),
      expression: "v2"
    }],
    staticClass: "drop-out"
  }, [_vm._v("商务合作")])])], 1), _vm._v(" "), _c('a', {
    staticClass: "affix-item qq-contact",
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=3281935475&site=qq&menu=yes",
      "alt": "业务咨询",
      "title": "业务咨询"
    },
    on: {
      "mouseenter": function($event) {
        _vm.v3 = true;
      },
      "mouseleave": function($event) {
        _vm.v3 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/QQ.png")
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v3),
      expression: "v3"
    }],
    staticClass: "drop-out"
  }, [_vm._v("业务咨询")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "affix-item wechat-contact",
    on: {
      "mouseenter": function($event) {
        _vm.v4 = true;
      },
      "mouseleave": function($event) {
        _vm.v4 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/wechat.png")
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v4),
      expression: "v4"
    }],
    staticClass: "drop-out"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon/qrcode2.png"),
      "width": "150",
      "alt": "关注我们",
      "title": "关注我们"
    }
  })])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210d6d6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affix.vue
// module id = 486
// module chunks = 15